module.exports = __webpack_public_path__ + "static/media/favicon_ffstars_v1.37c62efa.png";